<template>
<div id="toggle-container" v-if="totalClinics > 1">
    <hp5-button-decorator type="tertiary" v-if="!showMore">
        <button v-on:click="toggle">+ Show more virtual clinics</button>
    </hp5-button-decorator>
    <hp5-button-decorator type="tertiary" v-if="showMore">
        <button v-on:click="toggle">- Show less virtual clinics</button>
    </hp5-button-decorator>
</div>    
</template>

<script setup>
//Important context: the reason for toggling two buttons rather than toggling the text on one button is accessibility issues that arise from the latter approach

    const props = defineProps({
        showMore: Boolean
    })

    const emit = defineEmits(['toggle'])

    const { onlineClinics } = useFCPModel()   
    const totalClinics = computed(() => (onlineClinics.value ? onlineClinics.value.length : 0))

    const toggle = () => {
        emit('toggle', !props.showMore)
        if (props.showMore) {
          //use nextTick so the DOM elements are appropriately rendered first
          //need to go to the second online clinic in the list and find the focusable link element to move tab selector
          nextTick(() => {
            document.querySelectorAll('.online-clinics')[1].querySelector('.clinic-info hp5-heading a').focus()
          })
        }
    }

</script>

<style scoped lang="scss">

#toggle-container {
    display: grid;
    hp5-button-decorator {
      justify-self: center;
    }
}

</style>